import template from './sw-cms-el-preview-acris-blog-product-slider.html.twig';
import './sw-cms-el-preview-acris-blog-product-slider.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-product-slider', {
    template
});